export const userData = {
  iamUser: {
    password: null,
    username: 'managerIDE@mod.com',
    authorities: [
      {
        authority: 'ACCEPTDECLINEAVAILABLEFORM'
      },
      {
        authority: 'ACCESS_1099'
      },
      {
        authority: 'ACCESS_APINVOICE'
      },
      {
        authority: 'ACCESS_APPAYMENTS'
      },
      {
        authority: 'ACCESS_AR'
      },
      {
        authority: 'ACCESS_AUDIT_DRIVE_SAAS'
      },
      {
        authority: 'ACCESS_CUSTOMER'
      },
      {
        authority: 'ACCESS_EFORMS'
      },
      {
        authority: 'ACCESS_EMPLOYEE'
      },
      {
        authority: 'ACCESS_FS'
      },
      {
        authority: 'ACCESS_GL'
      },
      {
        authority: 'ACCESS_GLOBAL_SEARCH'
      },
      {
        authority: 'ACCESS_GL_INQUIRY'
      },
      {
        authority: 'ACCESS_MODTOOL'
      },
      {
        authority: 'ACCESS_OEMI'
      },
      {
        authority: 'ACCESS_ONDEMAND_PAYMENTS'
      },
      {
        authority: 'ACCESS_PAYMENT_REGISTER'
      },
      {
        authority: 'ACCESS_PO'
      },
      {
        authority: 'ACCESS_TIMECLOCK'
      },
      {
        authority: 'ACCESS_VENDOR'
      },
      {
        authority: 'ACCRPTS_FIN_ACCESS'
      },
      {
        authority: 'ACCRPTS_TB_ACCESS'
      },
      {
        authority: 'ADJUST_DMS_JOURNAL_ENTRY'
      },
      {
        authority: 'ADJUST_EMPLOYEE_TIMECARD'
      },
      {
        authority: 'ALLOW_INTERCOMPANY_POSTINGS'
      },
      {
        authority: 'ALLOW_MANUAL_CLOSEPO'
      },
      {
        authority: 'ALLOW_POSTING_AFTER_CUTOFF'
      },
      {
        authority: 'ALLOW_RESTRICTED_ACCT_INQUIRY'
      },
      {
        authority: 'ALLOW_RESTRICTED_JRNL_INQUIRY'
      },
      {
        authority: 'ALLOW_RESTRICTED_POSTING'
      },
      {
        authority: 'ALLOW_YTD_ADJUSTMENTS'
      },
      {
        authority: 'APPLY_AR_PAYMENT'
      },
      {
        authority: 'APPROVEFORMS'
      },
      {
        authority: 'APPROVER_PO_LEVEL1'
      },
      {
        authority: 'APPROVER_PO_LEVEL2'
      },
      {
        authority: 'APPROVER_PO_LEVEL3'
      },
      {
        authority: 'APPROVE_ACCOUNTING_PO'
      },
      {
        authority: 'APPROVE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'APPROVE_CHECK'
      },
      {
        authority: 'APPROVE_DMS_PURCHASE_ORDER'
      },
      {
        authority: 'APPROVE_PARTS_PO'
      },
      {
        authority: 'APPROVE_SERVICE_PO'
      },
      {
        authority: 'APPROVE_VEHICLE_PO'
      },
      {
        authority: 'APPROVE_VIRTUAL_CARD'
      },
      {
        authority: 'ASSIGN_ACCOUNTS'
      },
      {
        authority: 'ASYNC PERMISSION TEST'
      },
      {
        authority: 'AUTHORIZE_APCHECK'
      },
      {
        authority: 'AUTHORIZE_AP_VIRTUALCARD'
      },
      {
        authority: 'AUTHORIZE_AP_VIRTUAL_CARD'
      },
      {
        authority: 'AUTHORIZE_DMS_AP_PAYMENTS'
      },
      {
        authority: 'AUTHORIZE_MANUAL_CHECK'
      },
      {
        authority: 'AUTHORIZE_ONDEMAND_CHECK'
      },
      {
        authority: 'AUTHORIZE_ONDEMAND_FLOORING_CHECK'
      },
      {
        authority: 'BUILDFORM'
      },
      {
        authority: 'BULK_MAPPINGS_MANAGEMENT'
      },
      {
        authority: 'CADMIN'
      },
      {
        authority: 'CDCM_ACCESS_APP'
      },
      {
        authority: 'CDCM_ACCOUNTING_ACCESS'
      },
      {
        authority: 'CDCM_FUNCTIONAL_UNIT_CREATE'
      },
      {
        authority: 'CDCM_FUNCTIONAL_UNIT_DELETE'
      },
      {
        authority: 'CDCM_FUNCTIONAL_UNIT_LIST'
      },
      {
        authority: 'CDCM_FUNCTIONAL_UNIT_UPDATE'
      },
      {
        authority: 'CDCM_FUNCTIONAL_UNIT_VIEW'
      },
      {
        authority: 'CDCM_PARTS_ACCESS'
      },
      {
        authority: 'CDCM_SERVICE_ACCESS'
      },
      {
        authority: 'CONSUMERQUOTINGTOOL'
      },
      {
        authority: 'CONVERTED_ACCOUNTING'
      },
      {
        authority: 'CONVERTED_MISC'
      },
      {
        authority: 'CONVERTED_PARTS'
      },
      {
        authority: 'CONVERTED_PAYROLL'
      },
      {
        authority: 'CONVERTED_SALES'
      },
      {
        authority: 'CONVERTED_SERVICE'
      },
      {
        authority: 'CPCMANAGE'
      },
      {
        authority: 'CREATE_1099_FORMS'
      },
      {
        authority: 'CREATE_8300_FORM'
      },
      {
        authority: 'CREATE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'CREATE_CUSTOMER'
      },
      {
        authority: 'CREATE_DMS_ACCOUNTS_PAYABLE'
      },
      {
        authority: 'CREATE_DMS_DEAL'
      },
      {
        authority: 'CREATE_DMS_JOURNAL_ENTRY'
      },
      {
        authority: 'CREATE_DMS_PURCHASE_ORDER'
      },
      {
        authority: 'CREATE_EMPLOYEE'
      },
      {
        authority: 'CREATE_EMPLOYEE_PII'
      },
      {
        authority: 'CREATE_FINANCIAL_INSTITUTION'
      },
      {
        authority: 'CREATE_MANUAL_CHECK'
      },
      {
        authority: 'CREATE_ONDEMAND_CHECK'
      },
      {
        authority: 'CREATE_ONDEMAND_FLOORING_CHECK'
      },
      {
        authority: 'CREATE_PARTS_PURCHASE_ORDER'
      },
      {
        authority: 'CREATE_PAYROLL_REPORTS'
      },
      {
        authority: 'CREATE_PAYROLL_SETUPS'
      },
      {
        authority: 'CREATE_SERVICE_PURCHASE_ORDER'
      },
      {
        authority: 'CREATE_VEHICLE_PURCHASE_ORDER'
      },
      {
        authority: 'CREATE_VENDOR'
      },
      {
        authority: 'CUSTOMER_CREATE'
      },
      {
        authority: 'CUSTOMER_DELETE'
      },
      {
        authority: 'CUSTOMER_PII_READ'
      },
      {
        authority: 'CUSTOMER_PII_UPDATE'
      },
      {
        authority: 'CUSTOMER_UPDATE_CREDIT_LIMIT'
      },
      {
        authority: 'CUSTOMER_UPDATE_CUSTOMER_COMMENTS'
      },
      {
        authority: 'DC_DEALJACKETS_ACCESS'
      },
      {
        authority: 'DC_DOC_BINDER_ACCESS'
      },
      {
        authority: 'DECLINEDFORMSLIST'
      },
      {
        authority: 'DELETE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'DELETE_DMS_USERS'
      },
      {
        authority: 'DELETE_EMPLOYEE'
      },
      {
        authority: 'DELETE_EMPLOYEE_PII'
      },
      {
        authority: 'DELETE_PARTS_PURCHASE_ORDER'
      },
      {
        authority: 'DELETE_SERVICE_PURCHASE_ORDER'
      },
      {
        authority: 'DELETE_VEHICLE_PURCHASE_ORDER'
      },
      {
        authority: 'DELUSER'
      },
      {
        authority: 'DEPROVISIONFORM'
      },
      {
        authority: 'DIRECTRENDER'
      },
      {
        authority: 'DMAAP_SCAN_ADMIN'
      },
      {
        authority: 'DMAAP_TAG_ADMIN'
      },
      {
        authority: 'DMSACCESS'
      },
      {
        authority: 'DMSUSRLNK'
      },
      {
        authority: 'DMSUSRMGR'
      },
      {
        authority: 'DMS_COPY_USER'
      },
      {
        authority: 'DMS_EOAPI_ACCESS'
      },
      {
        authority: 'DRIVESAAS_READ CUSTOMER'
      },
      {
        authority: 'DRSAAS'
      },
      {
        authority: 'EDIT_DELETE_AR_COMMENTS'
      },
      {
        authority: 'EDIT_DMS_NEBULA'
      },
      {
        authority: 'EDIT_DMS_USERS'
      },
      {
        authority: 'EDIT_DMS_USERSCONFIG'
      },
      {
        authority: 'EDMEDITFORM'
      },
      {
        authority: 'EDMVIEWFORM'
      },
      {
        authority: 'ESIGN'
      },
      {
        authority: 'ETC_ADJUST_EMPLOYEE_TIMECARD'
      },
      {
        authority: 'ETC_APPROVE_ADJUST_TIMECARD'
      },
      {
        authority: 'ETC_CREATE_TIME_CLOCK_SETUPS'
      },
      {
        authority: 'ETC_CREATE_UPDATE_EMPLOYEE'
      },
      {
        authority: 'ETC_DELETE_EMPLOYEE_TIMECLOCK_DATA'
      },
      {
        authority: 'ETC_ENTER_TIME_CLOCK'
      },
      {
        authority: 'ETC_READ_EMPLOYEE'
      },
      {
        authority: 'ETC_VIEW_EMPLOYEE_TIMESHEETS'
      },
      {
        authority: 'ETC_VIEW_TIME_CARD'
      },
      {
        authority: 'ETC_VIEW_TIME_CLOCK_REPORTS'
      },
      {
        authority: 'EXPORTACTIVITYHISTORY'
      },
      {
        authority: 'FINALIZE_DMS_DEAL'
      },
      {
        authority: 'FORTELLIS_DEAL_JACKET_READ_ONLY'
      },
      {
        authority: 'GCM_ACCOUNTING_AP_INVOICE'
      },
      {
        authority: 'GCM_ACCOUNTING_CHECKS'
      },
      {
        authority: 'GCM_ACCOUNTING_FINANCIALSTATEMENTS'
      },
      {
        authority: 'GCM_ACCOUNTING_FINANCIAL_REPORTS'
      },
      {
        authority: 'GCM_ACCOUNTING_INTERIM_REPORTS'
      },
      {
        authority: 'GCM_ACCOUNTING_JOURNAL_ENTRIES'
      },
      {
        authority: 'GCM_ACCOUNTING_MEFINAL_REPORTS'
      },
      {
        authority: 'GCM_ACCOUNTING_PAYABLES_REPORTS'
      },
      {
        authority: 'GCM_ACCOUNTING_PAYMENT'
      },
      {
        authority: 'GCM_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'GCM_ACCOUNTING_RECEIVABLESSTATEMENTS'
      },
      {
        authority: 'GCM_ACCOUNTING_RECEIVABLES_REPORTS'
      },
      {
        authority: 'GCM_ACCOUNTING_TAXFORMS'
      },
      {
        authority: 'GCM_AUDIT'
      },
      {
        authority: 'GCM_CASH_RECEIPT'
      },
      {
        authority: 'GCM_CDK_SERVICE_APPOINTMENT_MEDIA'
      },
      {
        authority: 'GCM_CDK_SERVICE_INSPECTION_MEDIA'
      },
      {
        authority: 'GCM_CLASSIFICATION'
      },
      {
        authority: 'GCM_CREDIT_INQUIRY'
      },
      {
        authority: 'GCM_CVR_AL'
      },
      {
        authority: 'GCM_CVR_GA'
      },
      {
        authority: 'GCM_CVR_IL'
      },
      {
        authority: 'GCM_CVR_IN'
      },
      {
        authority: 'GCM_CVR_MA'
      },
      {
        authority: 'GCM_CVR_MD'
      },
      {
        authority: 'GCM_CVR_TITLE_REGISTRATION'
      },
      {
        authority: 'GCM_CVR_WV'
      },
      {
        authority: 'GCM_FORTELLIS_ORGANIZATION_API_AGREEMENT'
      },
      {
        authority: 'GCM_FORTELLIS_ORGANIZATION_APP_AGREEMENT'
      },
      {
        authority: 'GCM_LEASE_RENTAL_ACCOUNTING'
      },
      {
        authority: 'GCM_LEASE_RENTAL_CUSTOMER'
      },
      {
        authority: 'GCM_MISC_ACCOUNTING'
      },
      {
        authority: 'GCM_MISC_CONTENT'
      },
      {
        authority: 'GCM_MISC_PARTS'
      },
      {
        authority: 'GCM_MISC_PAYROLL'
      },
      {
        authority: 'GCM_MISC_SALES'
      },
      {
        authority: 'GCM_MISC_SERVICE'
      },
      {
        authority: 'GCM_MISC_SOC_AUDIT'
      },
      {
        authority: 'GCM_NEW_MIGRATED_CONTENT'
      },
      {
        authority: 'GCM_OEMI_GM_ATTACHMENTS'
      },
      {
        authority: 'GCM_PARTS_INVOICE_ACCOUNTING'
      },
      {
        authority: 'GCM_PARTS_INVOICE_CUSTOMER'
      },
      {
        authority: 'GCM_PARTS_INVOICE_FILE'
      },
      {
        authority: 'GCM_PAYROLL_CHECK_ACCOUNTING'
      },
      {
        authority: 'GCM_PAYROLL_CHECK_CUSTOMER'
      },
      {
        authority: 'GCM_SALES_CREDIT_APPLICATION'
      },
      {
        authority: 'GCM_SALES_CUSTOMER'
      },
      {
        authority: 'GCM_SALES_DEALS'
      },
      {
        authority: 'GCM_SEARCH'
      },
      {
        authority: 'GCM_SERVICE_INVOICE_ACCOUNTING'
      },
      {
        authority: 'GCM_SERVICE_INVOICE_CUSTOMER'
      },
      {
        authority: 'GCM_SERVICE_INVOICE_FILE'
      },
      {
        authority: 'GCM_SERVICE_INVOICE_INTERNAL'
      },
      {
        authority: 'GCM_SERVICE_INVOICE_WARRANTY'
      },
      {
        authority: 'GCM_SERVICE_REPAIRORDER_ACCOUNTING'
      },
      {
        authority: 'GCM_SERVICE_REPAIRORDER_CUSTOMER'
      },
      {
        authority: 'GCM_SERVICE_REPAIRORDER_TECHNICIAN'
      },
      {
        authority: 'GCM_SERVICE_REPORTS'
      },
      {
        authority: 'HUB_DDX_VIEW_DATA_SHARING'
      },
      {
        authority: 'HUB_ESTORE_ACCESS_LEGACY'
      },
      {
        authority: 'HUB_ESTORE_ACCESS_PARTNER'
      },
      {
        authority: 'HUB_ESTORE_ACCESS_TONER'
      },
      {
        authority: 'HUB_LENDERFORM_CREATE_FORM'
      },
      {
        authority: 'HUB_LENDERFORM_PLACE_ORDER'
      },
      {
        authority: 'I2P_PAYMENTS_REQUESTS'
      },
      {
        authority: 'IMPORTADMIN'
      },
      {
        authority: 'IMPORT_DEPOSITS'
      },
      {
        authority: 'INVENTORYQUOTINGTOOL'
      },
      {
        authority: 'ISSUE_REFUNDS'
      },
      {
        authority: 'LNKUSERALTID'
      },
      {
        authority: 'LOOKUP_HISTORY'
      },
      {
        authority: 'MANAGE'
      },
      {
        authority: 'MANAGEARTWORK'
      },
      {
        authority: 'MANAGEENTERPRISE'
      },
      {
        authority: 'MANAGEFORMS'
      },
      {
        authority: 'MANAGEMYFORMS'
      },
      {
        authority: 'MANAGEPRIVATEPROFILE'
      },
      {
        authority: 'MANAGESTORE'
      },
      {
        authority: 'MANAGESTOREMFA'
      },
      {
        authority: 'MANAGEVENDOR'
      },
      {
        authority: 'MANAGE_OEM_TEMPLATES'
      },
      {
        authority: 'MANAGE_SERVICE_OEM_INTEGRATION'
      },
      {
        authority: 'MANUAL_CLOSE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'MANUAL_CLOSE_PARTS_PURCHASE_ORDER'
      },
      {
        authority: 'MANUAL_CLOSE_SERVICE_PURCHASE_ORDER'
      },
      {
        authority: 'MANUAL_CLOSE_VEHICLE_PURCHASE_ORDER'
      },
      {
        authority: 'MDT_ASSIGN_ROLES'
      },
      {
        authority: 'MDT_ONBOARDING_TRACKING'
      },
      {
        authority: 'MDT_VIEW_REPORT'
      },
      {
        authority: 'MNGALLCFG'
      },
      {
        authority: 'MNGEINFO'
      },
      {
        authority: 'MNGEMLTEMPLATESPERM'
      },
      {
        authority: 'MNGENTERPRISEMFA'
      },
      {
        authority: 'MNGENTERPRISEPERM'
      },
      {
        authority: 'MNGENTHIERARCHYPERM'
      },
      {
        authority: 'MNGFEDERATION'
      },
      {
        authority: 'MNGIMPCFG'
      },
      {
        authority: 'MNGINDIVIDUALSTOREMFA'
      },
      {
        authority: 'MNGMFAAUDIT'
      },
      {
        authority: 'MNGPRODTOOLS'
      },
      {
        authority: 'MNGREPROCESS'
      },
      {
        authority: 'MNGROL'
      },
      {
        authority: 'MNGSTR'
      },
      {
        authority: 'MNGTMPLS'
      },
      {
        authority: 'MNGUSERMFA'
      },
      {
        authority: 'MNGUSR'
      },
      {
        authority: 'MNGVEHSCAN'
      },
      {
        authority: 'MODERN_DEAL_JACKET'
      },
      {
        authority: 'MRGUSR'
      },
      {
        authority: 'OVERRIDE_PRINTER_SETTINGS_AP_CHECK'
      },
      {
        authority: 'OVERRIDE_PRINTER_SETTINGS_ONDEMAND_CHECK'
      },
      {
        authority: 'PAYNOW_PAYMENTS'
      },
      {
        authority: 'PRE_INVOICE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'PRE_INVOICE_PARTS_PURCHASE_ORDER'
      },
      {
        authority: 'PRE_INVOICE_SERVICE_PURCHASE_ORDER'
      },
      {
        authority: 'PRE_INVOICE_VEHICLE_PURCHASE_ORDER'
      },
      {
        authority: 'PRINT_CHECK'
      },
      {
        authority: 'PRINT_MANUAL_CHECK'
      },
      {
        authority: 'PRINT_ONDEMAND_CHECK'
      },
      {
        authority: 'PRINT_ONDEMAND_FLOORING_CHECK'
      },
      {
        authority: 'PROSPECTQUOTINGTOOL'
      },
      {
        authority: 'PROVISIONAVAILABLEFORM'
      },
      {
        authority: 'PROVISIONFORM'
      },
      {
        authority: 'READ_AGING_SUMMARY'
      },
      {
        authority: 'READ_CUSTOMER'
      },
      {
        authority: 'READ_DMS_ACCOUNTS_PAYABLE'
      },
      {
        authority: 'READ_DMS_JOURNAL_ENTRY'
      },
      {
        authority: 'READ_EMPLOYEE'
      },
      {
        authority: 'READ_EMPLOYEE_NO_PII'
      },
      {
        authority: 'READ_EMPLOYEE_PII'
      },
      {
        authority: 'READ_FINANCIAL_INSTITUTION'
      },
      {
        authority: 'READ_FORTELLIS_SUBSCRIPTIONS'
      },
      {
        authority: 'READ_RECONCILIATION'
      },
      {
        authority: 'READ_VENDOR'
      },
      {
        authority: 'RECEIVE_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'RECONCILE_CHECKREGISTER'
      },
      {
        authority: 'RECONCILE_EPAYABLES'
      },
      {
        authority: 'RECURRING_JOURNAL_ENTRY'
      },
      {
        authority: 'REPORTING'
      },
      {
        authority: 'RESENDUSEREMAILPERM'
      },
      {
        authority: 'REVERSE_DMS_JOURNAL_ENTRY'
      },
      {
        authority: 'RUN_AD_HOC_AR_STATEMENTS'
      },
      {
        authority: 'RUN_AR_CLOSE'
      },
      {
        authority: 'RUN_AR_SCHEDULE'
      },
      {
        authority: 'RUN_FINAL_AR_STATEMENTS'
      },
      {
        authority: 'RUN_INTERIM_AR_STATEMENTS'
      },
      {
        authority: 'SAVE_JOURNAL_ENTRY'
      },
      {
        authority: 'SETESIGN'
      },
      {
        authority: 'SETUPCLOUDPRINTING'
      },
      {
        authority: 'SETUPS_SCHEMA_ACCESS_APP'
      },
      {
        authority: 'SETUPS_SCHEMA_CREATE'
      },
      {
        authority: 'SETUPS_SCHEMA_DELETE'
      },
      {
        authority: 'SETUPS_SCHEMA_LIST'
      },
      {
        authority: 'SETUPS_SCHEMA_PUBLISH'
      },
      {
        authority: 'SETUPS_SCHEMA_UPDATE'
      },
      {
        authority: 'SETUPS_SCHEMA_VIEW'
      },
      {
        authority: 'SUBSCRIPTION_MANAGEMENT'
      },
      {
        authority: 'TAKE_PAYMENTS'
      },
      {
        authority: 'TESTASYNC4'
      },
      {
        authority: 'TESTRENDER'
      },
      {
        authority: 'TESTSIGN'
      },
      {
        authority: 'TRANSMIT_STATEMENT'
      },
      {
        authority: 'UNDO_RECEIVED_PURCHASE_ORDER'
      },
      {
        authority: 'UNPOSTED_ENTRIES'
      },
      {
        authority: 'UPDATE_CHECK_NUMBER_AP_CHECK'
      },
      {
        authority: 'UPDATE_CHECK_NUMBER_ONDEMAND_CHECK'
      },
      {
        authority: 'UPDATE_EMPLOYEE'
      },
      {
        authority: 'UPDATE_EMPLOYEE_PII'
      },
      {
        authority: 'UPDATE_RECONCILIATION'
      },
      {
        authority: 'UPDATE_VENDOR'
      },
      {
        authority: 'UPDATE_VENDOR_PII'
      },
      {
        authority: 'UPLOADARTWORK'
      },
      {
        authority: 'VCSETUP'
      },
      {
        authority: 'VCSYND'
      },
      {
        authority: 'VENDOR_CREATE'
      },
      {
        authority: 'VENDOR_CREATE_PII'
      },
      {
        authority: 'VENDOR_READ'
      },
      {
        authority: 'VENDOR_READ_PII'
      },
      {
        authority: 'VIEWARTWORK'
      },
      {
        authority: 'VIEWARTWORKMANAGEMENT'
      },
      {
        authority: 'VIEWAVAILABLEFORMS'
      },
      {
        authority: 'VIEWEMAILSENTSTATUS'
      },
      {
        authority: 'VIEWFETRINSTNC'
      },
      {
        authority: 'VIEWFORMS'
      },
      {
        authority: 'VIEWMYFORMPREVIEW'
      },
      {
        authority: 'VIEWPCKGINSTNC'
      },
      {
        authority: 'VIEWPROFILE'
      },
      {
        authority: 'VIEW_AP'
      },
      {
        authority: 'VIEW_AR_DASHBOARD'
      },
      {
        authority: 'VIEW_AR_STATEMENTS'
      },
      {
        authority: 'VIEW_CHECKREGISTER'
      },
      {
        authority: 'VIEW_DEPOSIT_HISTORY'
      },
      {
        authority: 'VIEW_DMS_APPLICATIONS'
      },
      {
        authority: 'VIEW_DMS_ASCOOKIE'
      },
      {
        authority: 'VIEW_DMS_AUTOIMPORT'
      },
      {
        authority: 'VIEW_DMS_AUTOIMPORTCOMPONENTS'
      },
      {
        authority: 'VIEW_DMS_AUTOIMPORTREADY'
      },
      {
        authority: 'VIEW_DMS_COMPANIES'
      },
      {
        authority: 'VIEW_DMS_DEAL'
      },
      {
        authority: 'VIEW_DMS_DMSADMINS'
      },
      {
        authority: 'VIEW_DMS_FRS'
      },
      {
        authority: 'VIEW_DMS_FRS_LOGS'
      },
      {
        authority: 'VIEW_DMS_FRS_PARAMS'
      },
      {
        authority: 'VIEW_DMS_NEBULA'
      },
      {
        authority: 'VIEW_DMS_PERMISSIONS'
      },
      {
        authority: 'VIEW_DMS_PRINTERS'
      },
      {
        authority: 'VIEW_DMS_PROFILES'
      },
      {
        authority: 'VIEW_DMS_PURCHASE_ORDER'
      },
      {
        authority: 'VIEW_DMS_RELINKUSERS'
      },
      {
        authority: 'VIEW_DMS_UICOMPATIBILITY'
      },
      {
        authority: 'VIEW_DMS_UNIXPROFILES'
      },
      {
        authority: 'VIEW_DMS_USEREXCEPTIONS'
      },
      {
        authority: 'VIEW_DMS_USERS'
      },
      {
        authority: 'VIEW_DMS_USERSCONFIG'
      },
      {
        authority: 'VIEW_EMPLOYEE_TIMESHEETS'
      },
      {
        authority: 'VIEW_PAYMENT_REGISTER'
      },
      {
        authority: 'VIRTUAL_TERMINAL'
      },
      {
        authority: 'VOID_ACCOUNTING_PURCHASE_ORDER'
      },
      {
        authority: 'VOID_APCHECK'
      },
      {
        authority: 'VOID_AP_VIRTUALCARD'
      },
      {
        authority: 'VOID_DMS_ACCOUNTS_PAYABLE'
      },
      {
        authority: 'VOID_DMS_PURCHASE_ORDER'
      },
      {
        authority: 'VOID_FLOORING_CHECK'
      },
      {
        authority: 'VOID_ONDEMAND_CHECK'
      },
      {
        authority: 'VOID_PARTS_PURCHASE_ORDER'
      },
      {
        authority: 'VOID_SERVICE_PURCHASE_ORDER'
      },
      {
        authority: 'VOID_VEHICLE_PURCHASE_ORDER'
      },
      {
        authority: 'WRITEOFF_JOURNAL_ENTRY'
      },
      {
        authority: 'testtest1'
      },
      {
        authority: 'testtest2'
      }
    ],
    accountNonExpired: true,
    accountNonLocked: true,
    credentialsNonExpired: true,
    enabled: true,
    enterprise: {
      id: 'E337424'
    },
    assignments: [
      {
        stores: [
          {
            storeId: 'S100108940',
            name: 'Store 3 Company 7',
            defaultStore: false
          },
          {
            storeId: 'S100111644',
            name: 'Store 5 Company 6',
            defaultStore: false
          },
          {
            storeId: 'S100111624',
            name: 'Store 4 Company 5',
            defaultStore: false
          },
          {
            storeId: 'S100122457',
            name: 'BERGER CHEVROLET',
            defaultStore: false
          },
          {
            storeId: 'S100108519',
            name: 'Store 2 Company 3',
            defaultStore: false
          },
          {
            storeId: 'S100106216',
            name: 'Store 1 Company 1',
            defaultStore: true
          }
        ],
        roles: [
          {
            roleGuid: 'E1A25660C0822198E053F108636461A1',
            code: 'AP_OFFICE_MANAGER_FROM_TEMPLATE'
          },
          {
            roleGuid: 'D8B0BC60BB8A558EE053F10863641ADC',
            code: 'NOCUSTOMERSEARCH_READ_PERMISSION'
          },
          {
            roleGuid: 'EC16BC119CC413BCE053F10863643AD3',
            code: 'PAYMENT_REGISTER_DRIVE_SAAS'
          },
          {
            roleGuid: 'EAF006773A74320BE053F10863642122',
            code: 'VENDOR_MANAGER'
          },
          {
            roleGuid: 'F31E2A7ED80C1095E053F1086364D213',
            code: 'PAYMENT_REGISTER_ONBOARDING_ROLE_'
          },
          {
            roleGuid: 'E31E5392685B7114E053F1086364EA24',
            code: 'AP_PAYMENTS'
          },
          {
            roleGuid: 'E3204DA54F473401E053F108636498ED',
            code: '_'
          },
          {
            roleGuid: 'E3145309A7FF1B88E053F1086364B990',
            code: 'AP_INVOICE'
          },
          {
            roleGuid: '043312B686F27FF6E063F1086364DFA0',
            code: '_AR_MANAGER'
          },
          {
            roleGuid: 'D9D7671487BA4C3E9317DBD06443CD30',
            code: 'CUSTOMER_MANAGER'
          },
          {
            roleGuid: 'E82AF4D89CED0ACDE053F108636489C8',
            code: 'E_FORMS'
          },
          {
            roleGuid: '6A84A49858E64BAFB7205309021617F3',
            code: 'EMPLOYEE_MANAGER'
          },
          {
            roleGuid: 'CF4273E554117CAFE053F10863647233',
            code: 'ENTERPRISE_ADMINISTRATOR'
          }
        ]
      }
    ],
    firstName: 'Manager',
    middleName: null,
    lastName: 'IDE',
    locale: 'en_US',
    isServiceUser: false
  },
  extendedAccountInfo: [
    {
      storeId: 'S100108940',
      storeName: 'Store 3 Company 7',
      companyId: '7',
      accounts: ['PLF-A'],
      departmentIds: ['D100095666']
    },
    {
      storeId: 'S100111644',
      storeName: 'Store 5 Company 6',
      companyId: '6',
      accounts: ['PLF-A'],
      departmentIds: ['D100095666']
    },
    {
      storeId: 'S100111624',
      storeName: 'Store 4 Company 5',
      companyId: '5',
      accounts: ['PLF-A'],
      departmentIds: ['D100095666']
    },
    {
      storeId: 'S100122457',
      storeName: 'BERGER CHEVROLET',
      companyId: '11',
      accounts: ['BC11-A'],
      departmentIds: ['D100119897']
    },
    {
      storeId: 'S100108519',
      storeName: 'Store 2 Company 3',
      companyId: '3',
      accounts: ['TOY-A'],
      departmentIds: ['D100094776']
    },
    {
      storeId: 'S100106216',
      storeName: 'Store 1 Company 1',
      companyId: '1',
      accounts: ['TOY-A'],
      departmentIds: ['D100094776']
    }
  ],
  eisGroups: {
    groups: [
      {
        name: '1 - Store 1 Company 1',
        groupId: 'G000002469',
        type: 'GL_GROUP',
        organizationUnits: ['S100106216'],
        companyId: '1'
      },
      {
        name: '3 - Store 2 Company 3',
        groupId: 'G000002470',
        type: 'GL_GROUP',
        organizationUnits: ['S100108519'],
        companyId: '3'
      },
      {
        name: '5 - Store 4 Company 5',
        groupId: 'G000002472',
        type: 'GL_GROUP',
        organizationUnits: ['S100111624'],
        companyId: '5'
      },
      {
        name: '6 - Store 5 Company 6',
        groupId: 'G000002473',
        type: 'GL_GROUP',
        organizationUnits: ['S100111644'],
        companyId: '6'
      },
      {
        name: 'BERGER CHEVROLET',
        groupId: 'G000003471',
        type: 'GL_GROUP',
        organizationUnits: ['S100122457'],
        companyId: '11'
      },
      {
        name: 'Store 3 Company 7',
        groupId: 'G000003472',
        type: 'GL_GROUP',
        organizationUnits: ['S100108940'],
        companyId: '7'
      },
      {
        name: 'TOY-A - Toyota Accounting2',
        groupId: 'G000003194',
        type: 'ACCOUNTING_GROUP',
        organizationUnits: ['G000002469', 'G000002470'],
        companyId: null
      },
      {
        name: 'PLF-A - PLF Accounting',
        groupId: 'G000003603',
        type: 'ACCOUNTING_GROUP',
        organizationUnits: ['G000002473', 'G000002472', 'G000003472'],
        companyId: null
      }
    ]
  }
};

export const userAccount = {
  companyId: '1',
  departmentName: 'TOY-A'
};
